<template>
  <div v-loading="loadingMatter" style="min-height: 100px;">
    <div
      class="p-matter-content-wrap"
      v-for="(item,index) in recentlyMatterData"
      :key="index"
      @click="goMatterDetail(item,index)"
    >
      <div class="p-icon ibass ibass-dot"></div>
      <div class="p-matter-content">
        <div class="p-matter-title-info">
          <div class="p-matter-name" :title="item.name">{{item.name}}</div>
          <div class="p-matter-status">{{ item.isValid === '1' ? item.statusName : '已删除' }}</div>
        </div>
        <div class="p-matter-manager"
          :title="filterClients(item.clients)"
          v-if="item.clients && item.clients.length > 0"
        >{{ filterClients(item.clients) }}</div>
        <div class="p-matter-type-info">
          <div
            class="p-matter-type"
            v-if="item.childrenMatterTypeName"
            :title="item.childrenMatterTypeName"
          >项目类型：{{ item.childrenMatterTypeName }}</div>
          <div
            class="p-process-type"
            v-if="item.caseProcessName"
            :title="item.caseProcessName"
          >
            程序类型：{{ item.caseProcessName }}
          </div>
        </div>
      </div>
    </div>
    <div class="blankText" v-if="showMatterText">暂无最近浏览项目</div>
  </div>
</template>

<script>
import indexService from '../../../service/index'
export default {
  name: 'RecentlyMatter',
  props: {
    showMatter: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      loadingMatter: true,
      recentlyMatterData: [],
      showMatterText: false
    }
  },
  created () {
    this.getRecentlyMatter()
  },
  methods: {
    goMatterDetail (params) {
      // 权限：进入项目详情权限 （部门，子部门，项目）；没权限提示：您暂无该项目查看权限
      // 已删除项目给予友好提示：该项目已被删除 （'1'：未删除，其余都是已删除）
      // this.$postMessage.fromWorkFlatMatterDetail(params.matterId)
      // console.log(params.isValid)
      if (params.isValid === '0') {
        this.$postMessage.toast({ msg: '该项目已被删除' })
      } else if (params.isValid === '1') {
        window.parent.postMessage({
          action: 'fromWorkFlatMatterDetails',
          data: {
            matterId: params.pkId
          }
        }, process.env.VUE_APP_IFRAME_DOMAIN)
      }
      this.$analysis.track('查看最近浏览项目_最近浏览/工作台模块')
    },
    // 客户名称过滤
    filterClients (clients) {
      return clients.map((client, index) => {
        return client.clientName
      }).join(',')
    },
    async getRecentlyMatter () {
      this.loadingMatter = true
      let response = null
      try {
        response = await indexService.getRecentlyMatter()
        if (response.isSuccess) {
          if (response.data && response.data.length > 0) {
            this.recentlyMatterData = response.data
            this.showMatterText = false
          } else {
            this.showMatterText = true
          }
          this.loadingMatter = false
        } else {
          this.$postMessage.toast({ msg: response.message || response.resultMsg })
          this.loadingMatter = false
        }
      } catch (e) {
        this.loadingMatter = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .p-matter-content-wrap {
    width 100%;
    display flex;

    /*align-items center;*/
    /*justify-content space-between;*/
    .p-icon {
      color #C4C4C4;
      padding-top 3px;
    }
    .p-matter-content {
      width calc(100% - 30px);
      flex-grow 1;
      margin-left 14px;
      box-sizing border-box;
      padding-bottom 14px;
      border-bottom 1px solid #f1f2f3;
      margin-bottom 10px;

      .p-matter-title-info {
        display flex;
        font-size 14px;
        color #000000;
        margin-bottom: 8px;
        .p-matter-name {
          max-width 128px
          text-overflow ellipsis;
          white-space nowrap;
          overflow hidden;
          cursor: pointer;
        }
        .p-matter-status {
          height 20px;
          line-height 20px
          padding 0 12px
          font-size 12px;
          border 1px solid #f1f2f3;
          border-radius 10px;
          margin-left 10px;
          text-align center;
        }
      }
      .p-matter-manager {
        max-width 100%;
        font-size 12px;
        color #8590A6;
        text-overflow ellipsis;
        white-space nowrap;
        overflow hidden;
        margin-bottom 5px;
        cursor: pointer;
      }
      .p-matter-type-info {
        font-size 12px;
        color #8590A6;
        .p-matter-type {
          max-width 100%;
          text-overflow ellipsis;
          white-space nowrap;
          overflow hidden;
          cursor pointer;
        }
        .p-process-type {
          margin-top 5px;
          max-width 100%;
          text-overflow ellipsis;
          white-space nowrap;
          overflow hidden;
          cursor pointer;
        }
      }
    }
  }
  .blankText {
    font-size 14px;
    text-align center;
    margin-top 30px;
    color #8c939d;
  }
</style>
